import { render } from "./TronEduExamEditor.vue?vue&type=template&id=25614079"
import script from "./TronEduExamEditor.vue?vue&type=script&lang=js"
export * from "./TronEduExamEditor.vue?vue&type=script&lang=js"

import exportComponent from "/home/olt/CloudRaiseWebSite/vue/client/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__